/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import { useContext } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GeneralContext } from '../../app-context/GeneralContext';
import { GET_STORE_BY_USER } from './graphql';

export function useGetStore() {
  const { setErrorMessage } = useContext(GeneralContext);
  const [GetStoreByUser, { loading: apiLoading }] = useLazyQuery(
    GET_STORE_BY_USER,
    { fetchPolicy: 'network-only' },
  );

  async function getStoreByUser({ userId }) {
    try {
      const res = await GetStoreByUser({
        variables: { userId },
      });
      if (res.data.getStoreByUser.code === 200) {
        return res.data.getStoreByUser.store;
      }
      return null;
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  return {
    getStoreByUser,
    loading: apiLoading,
  };
}
